import { gql } from '@apollo/client';
import { LeaveSubtypeFragment } from './leave-subtype.fragment';
export const EditLeaveSubtype = gql `
    mutation EditLeaveSubtype(
        $institutionSetId: InstitutionSetId!
        $leaveSubTypeId: StaffLeaveSubTypeId!
        $input: StaffLeaveSubTypeInput!
    ) {
        staffhours {
            leaves {
                subtypes {
                    updateV2(institutionSetId: $institutionSetId, leaveSubTypeId: $leaveSubTypeId, input: $input) {
                        ...LeaveSubtypeFragment
                    }
                }
            }
        }
    }
    ${LeaveSubtypeFragment}
`;
